import { DurationService } from './duration.service';
import { ImageUploaderServce } from './image.uploader.service';
import { MapboxService } from './mapbox.service';

export const SHARED_SERVICES = [ImageUploaderServce, MapboxService, DurationService];
